import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[csmsDragAndDrop]',
})
export class DragAndDropDirective {
    @Output() fileDropped = new EventEmitter<FileList>();

    @HostBinding('class.fileover') fileOver: boolean;

    @HostListener('mouseover', ['$event']) onMouseOver($event: DragEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.fileOver = true;
    }

    @HostListener('mouseleave', ['$event']) onMouseLeave($event: DragEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.fileOver = false;
    }

    @HostListener('dragover', ['$event']) onDragOver($event: DragEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.fileOver = true;
    }

    @HostListener('dragleave', ['$event']) onDragLeave($event: DragEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.fileOver = false;
    }

    @HostListener('drop', ['$event']) ondrop($event: DragEvent) {
        $event.preventDefault();
        $event.stopPropagation();

        this.fileOver = false;
        const files = $event.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}
